export enum CommandType {
  SUBMIT_PROMPT = 'SUBMIT_PROMPT',
  INJECT_PROMPT = 'INJECT_PROMPT',
  SUBMIT_OPTION = 'SUBMIT_OPTION',
  SUBMIT_ANSWERS = 'SUBMIT_ANSWERS',
  INTERRUPT_AGENT = 'INTERRUPT_AGENT',
  RESUME_AGENT = 'RESUME_AGENT',
  ERROR_RECOVERY = 'ERROR_RECOVERY',
  START_SESSION = 'START_SESSION',
  RESUME_SESSION = 'RESUME_SESSION',
  END_SESSION = 'END_SESSION',
  ARCHIVE_SESSION = 'ARCHIVE_SESSION',
}
